import React, { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

/**
 * Card fields render inside Stripe's own iframe (PaymentElement) and
 * confirmPayment talks directly to Stripe from the browser — raw card data
 * never touches our servers.
 */
const StripeCheckoutForm = ({ violation, primaryColor }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    // Note: deliberately does NOT flip any parent-level "processing" state
    // that would unmount this component — confirmPayment needs the Payment
    // Element to stay mounted for its whole (awaited) duration, or Stripe.js
    // throws "elements should have a mounted Payment Element".
    setSubmitting(true);
    setErrorMessage(null);

    const { error } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: window.location.origin + '/violations/' + violation.violation_number + '/payment-success',
      },
    });

    if (error) {
      setSubmitting(false);
      setErrorMessage(error.message);
      return;
    }

    // No further redirect needed (e.g. the card didn't require 3DS) —
    // payment_intent.succeeded will arrive via stripeWebhook shortly after.
    window.location.href = '/violations/' + violation.violation_number + '/payment-success';
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {errorMessage && (
        <div className="invalid-feedback" style={{ display: 'block', marginTop: 8 }}>
          {errorMessage}
        </div>
      )}
      <Row style={{ marginTop: 16 }}>
        <Button
          type="submit"
          className="btn btn-lg"
          style={{ color: 'white', width: '100%', backgroundColor: primaryColor, borderColor: primaryColor }}
          disabled={!stripe || submitting}
        >
          {submitting ? 'Processing...' : 'Pay now'}
        </Button>
      </Row>
    </form>
  );
};

export default StripeCheckoutForm;
